import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormError from 'components/FormError';
import SelectSearchField from 'components/SelectSearchField';

let ChangeSimoDeviceAccountForm = ({ simoAccounts, handleSubmit, error }) => {
  const simoAccountsOptions =
    simoAccounts && simoAccounts.length
      ? simoAccounts.map((acc) => ({ name: acc.name, value: acc.id }))
      : [];

  return (
    <form onSubmit={handleSubmit}>
      {/* do not remove this weird div block
          workaround/fix for the desktop safari auto focus bug 
       */}
      <div
        style={{
          position: 'absolute',
          opacity: '0',
          left: 0,
          top: 0,
          width: '1px',
          height: '1px',
          zIndex: '-1',
          pointerEvents: 'none',
        }}
      >
        <Field
          component={SelectSearchField}
          name="new_account_id_fake"
          label="test"
          options={simoAccountsOptions}
          placeholder="test"
          hideEmptyWhenHasValue={true}
          formName="changeAccount"
        />
        <input />
      </div>
      <Field
        component={SelectSearchField}
        name="new_account_id"
        label="Simo Account Name"
        options={simoAccountsOptions}
        placeholder="Select account name"
        hideEmptyWhenHasValue={true}
        formName="changeAccount"
      />
      {error && <FormError error={error} />}
      <br />
      <button className="btn btn-primary">Save Account Name</button>
    </form>
  );
};

const validate = (values) => {
  let errors = {};

  if (!values.new_account_id) {
    errors.new_account_id = 'Required';
  }

  return errors;
};

ChangeSimoDeviceAccountForm = reduxForm({
  form: 'changeAccount',
  validate,
  enableReinitialize: true,
})(ChangeSimoDeviceAccountForm);

export default ChangeSimoDeviceAccountForm;
